import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import { theme } from 'theme/MainTheme';
import { useTranslation } from 'react-i18next';

const RodoWrapper = styled.div`
  position: fixed;
  display: flex;
  flex-direction: row;
  align-items: center;
  bottom: 0;
  background-color: ${theme.dark};
  color: ${theme.white};
  font-weight: ${theme.bold};
  font-size: 1.3rem;
  padding: 1.5rem 8rem;
  z-index: 1201;
  width: 100vw;
  .rodo-inf {
    margin-right: 1rem;
  }
  a {
    color: ${theme.white};
  }
  @media (max-width: 700px) {
    font-size: ${theme.fontSize.xs};
    padding: 1.5rem;
    flex-direction: column;
    .rodo-inf {
      padding-bottom: 1rem;
      margin-right: 0;
    }
  }
`;

const Rodo = () => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = useState(Boolean(localStorage.getItem('rodo')));

  const acceptRodo = () => {
    localStorage.setItem('rodo', 'true');
    setAccepted(true);
  };

  return (
    <div>
      {!accepted && (
        <RodoWrapper>
          <div className="rodo-inf">
            {t('rodo_inf')} <a href="/information_clause">{t('more')}</a>
          </div>
          <Button
            type="button"
            variant="contained"
            onClick={acceptRodo}
            size="large"
            sx={{
              backgroundColor: theme.primary,
              fontWeight: theme.bold,
              maxHeight: '30px',
              maxWidth: '70px',
            }}
          >
            {t('accept')}
          </Button>
        </RodoWrapper>
      )}
    </div>
  );
};

export default Rodo;
